import emitter from './Emitter'
import HeSocket from './HeSocket'
// import LocalSocket from './LocalSocket'

// TODO: choose socket in diff event

let Scoket = HeSocket
emitter.setup(Scoket.prototype)

export default Scoket
